<template>
    <v-form v-model="formValido" ref="formInterno">
        <div :key="componentKey">
            <div class="d-flex">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[v => !!v || 'CNPJ é obrigatório']" 
                            clearable outlined label="CNPJ" v-model="objNf.cnpj" @blur="getCnpjInfo(objNf.cnpj)" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="8">
                        <v-text-field 
                            :rules="[
                                v => !!v || 'E-mail é obrigatório',
                                v => /.+@.+\..+/.test(v) || 'E-mail inválido'
                            ]"
                            clearable outlined label="Email" v-model="objNf.email" />
                    </v-col>
                </v-row>
            </div>

            <div>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cep"
                            clearable
                            outlined
                            label="CEP"
                            :rules="[v => !!v || 'CEP é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cidade"
                            clearable
                            outlined
                            label="Cidade"
                            :rules="[v => !!v || 'Cidade é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.codigoCidade"
                            clearable
                            outlined
                            label="Código da Cidade"
                            :rules="[v => !!v || 'Código é obrigatório']" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.logradouro"
                            clearable
                            outlined
                            label="Logradouro"
                            :rules="[v => !!v || 'Logradouro é obrigatório',]"
                        />
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.bairro"
                            clearable
                            outlined
                            label="Bairro"
                            :rules="[v => !!v || 'Bairro é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.numero"
                            clearable
                            outlined
                            label="Número"
                        />
                    </v-col>

                </v-row>
            </div>

            <div>
                <v-row>

                    <v-col cols="12" sm="6" md="10">
                        <v-text-field
                            v-model="objNf.complemento"
                            clearable
                            outlined
                            label="Complemento"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                        <v-text-field 
                            :rules="[v => !!v || 'UF é obrigatório']"  
                            clearable outlined 
                            label="UF" 
                            v-model="objNf.uf" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            label="Condições de Pagamento" 
                            v-model="objNf.condPag" 
                            :items="['á vista', 'á prazo']" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-combobox
                            label="Meio de Pagamento"
                            v-model="objNf.meioPagamento" 
                            :items="meioPagamentoOptions" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete 
                            v-model="objNf.cfop"
                            :items="cfops" 
                            item-text="codigo"
                            item-value="codigo" 
                            label="CFOP" 
                            dense 
                            outlined
                            @change="selectedCfop"
                        >
                            <template v-slot:item="{ item }">
                                <div class="d-flex flex-column">
                                    <div class="font-weight-bold">{{ item.codigo }}</div>
                                    <div>{{ item.descricao }}</div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            clearable 
                            outlined 
                            label="Natureza de Operação" 
                            v-model="objNf.naturezaOp" 
                            readonly
                            :key="componentKey"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            v-model="objNf.operacaoFiscal"
                            :items="operacaoFiscalOptions" 
                            label="Operação Fiscal" 
                            dense 
                            outlined
                            readonly
                        ></v-combobox>
                    </v-col>

                    <!-- <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            type="date" 
                            clearable 
                            outlined 
                            
                            label="Data de Entrada/Saída" 
                            v-model="objNf.dataSaida" 
                        />
                    </v-col> -->

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            clearable
                            outlined
                            label="Código Benefício Fiscal"
                            v-model="objNf.codigoBeneficioFiscal"
                        />
                    </v-col>
                </v-row>

            </div>

        </div>

        <div class="d-flex align-center">
            <v-checkbox v-model="objNf.addRetirada" />
            <label>Adicionar Informações de Retirada/Entrega</label>
        </div>
        
        <!-- NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): esta nota é baseada no
        JOB mas SEM Romaneio (não passa por Lista de Embarque/Expedição) — o card de Romaneios fica
        oculto e, em seu lugar, os itens da nota vêm diretamente do JOB selecionado (ProjectItens),
        com o usuário escolhendo quais entram. Ver getJobItensDiretos()/jobItensSelecionados abaixo. -->
        <v-card v-if="isVendaFutura" class="mb-5">
            <v-card-title>
                Itens do Job
            </v-card-title>
            <v-card-text>
                <v-autocomplete
                    v-model="jobItensSelecionados"
                    :items="jobItensDisponiveis"
                    :loading="loadingJobItensDiretos"
                    item-text="descricao"
                    label="Selecione o(s) item(ns) do Job para esta nota"
                    hint="Os itens selecionados aqui entram na tabela de Itens de Nota Fiscal abaixo, já com NCM/CEST/impostos do cadastro do Job. Também é possível clicar numa linha já carregada para ajustar os valores."
                    persistent-hint
                    dense
                    chips
                    outlined
                    multiple
                    return-object
                >
                    <template v-slot:item="{ item }">
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">{{ item.itemCodigo || item.codigo }} - {{ item.descricao }}</div>
                        </div>
                    </template>
                </v-autocomplete>
            </v-card-text>
        </v-card>

        <v-card v-if="!isVendaFutura">
            <v-card-title>
                Romaneios
            </v-card-title>
            <v-autocomplete
                v-model="objNf.romaneio"
                :items="romaneios" 
                :item-text="romaneioItemText"
                item-value="_id" 
                :item-disabled="romaneioIndisponivel"
                label="Romaneio" 
                dense 
                chips
                outlined 
                multiple
                return-object
            >
                <template v-slot:item="{ item, on, attrs }">
                    <v-list-item
                        v-bind="attrs"
                        v-on="romaneioIndisponivel(item) ? { click: () => alertarRomaneioIndisponivel(item) } : on"
                        :disabled="romaneioIndisponivel(item)"
                        class="w-100"
                        style="cursor: pointer;"
                    >
                        <v-list-item-content style="pointer-events: none;">
                            <v-list-item-title>{{ romaneioItemText(item) }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon v-if="romaneioIndisponivel(item)" style="pointer-events: none;">
                            <v-icon color="warning">mdi-alert-circle-outline</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </template>
            </v-autocomplete>
        </v-card>
            

        <div class="mb-5 mt-5" v-if="objNf.condPag == 'á prazo'" key="componentKey">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }}
                </v-card-title>
                <v-row class="mb-3" style="gap: 16px;">
                    <v-col cols="12" sm="6" md="4">
                        <v-card color="#e3f2fd" class="pa-3" outlined>
                            <div class="font-weight-bold">Valor Nota</div>
                            <div style="font-size: 1.2em; color: #1976d2;">
                                {{ valorNotaFormatado }}
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-card color="#e8f5e9" class="pa-3" outlined>
                            <div class="font-weight-bold">Total com Impostos</div>
                            <div style="font-size: 1.2em; color: #388e3c;">
                                {{ totalComImpostosFormatado }}
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :key="`parcela-${totalComImpostosInCents()}-${parcelas.length}`"
                            :rules="[
                                () => validarTotalParcelas()
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()" v-if="podeAdicionarParcela()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)" v-if="parcelas.length >= 2">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>

        <v-card class="mb-5 mt-5">
            <v-card-title>
                Itens de Nota Fiscal
            </v-card-title>

            <TableItensNotaFiscal 
                :addItem="false"
                :readyall="true"
                :schemaName="'FisPreDocEmiItem'"
                :itemsByRomaneio="(temRomaneio || isVendaFutura) ? osItems : []"
                :open="openItem"
                :jobSelected="jobSelected"
                :isNfRemessa="isNfRemessa"
                :isNfReferenciada="isNfReferenciada"
                :isDuplicating="isDuplicating"
                relation
                :ids="(temRomaneio || isVendaFutura) ? objNf.itens : []"
                :item="(temRomaneio || isVendaFutura) ? arrayItems : []"
                @save-item="
                ($event) => {
                    this.arrayItems = [...$event];
                    this.sumItems();
                }"
                @update-total-com-impostos="totImpostos"
            />
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Transportadora
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete 
                            v-model="objNf.transportadora" 
                            :items="transportadoras" 
                            item-text="razaoSocial"
                            item-value="id" 
                            label="Transpostadora" 
                            dense 
                            outlined 
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.quantidade" label="Quantidade" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.especie" label="Especie" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.marca" label="Marca" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.numeracao" label="Numeração" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoBruto" label="Peso Bruto KG" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoLiquido" label="Peso Liquido KG" outlined />
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Informações Adicionais
            </v-card-title>
            <v-card-text>
                <v-textarea
                    v-model="objNf.informacaoAdd"
                    label="Informação Adionais"
                    outlined
                ></v-textarea>
            </v-card-text>
        </v-card>

        <v-expansion-panels multiple>
        </v-expansion-panels>
        
    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
import TableItensNotaFiscal from './TableItensNotaFiscal.vue';
export default {
    name: 'NotaFiscal',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'pacelasCads', 'valorNota', 'jobSelected', 'romaneios', 'isNfRemessa', 'isNfReferenciada', 'isDuplicating', 'isVendaFutura'],
    components: {
        TableItensNotaFiscal,
        //CreateItensNotaFiscalView: () => import('./CreateItensNotaFiscalView.vue')
    },
    data(){
        return {
            expasionInfoGerais: false,
            salesOrders: [],
            openItem: false,
            arrayItems: [],
            componentKey: 0,
            formValido: false,
            searchNotaChaveAcesso: '',
            osItems: [],
            // NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura)
            jobItensDisponiveis: [],
            jobItensSelecionados: [],
            loadingJobItensDiretos: false,
            ultimoJobIdCarregado: null,
            transportadoras: [],
            cfops: [],
            // Removido o flag, vamos garantir atualização reativa
            operacaoFiscalOptions: ["Entrada", "Saída"],
            meioPagamentoOptions: [
                "Dinheiro",
                "Cheque",
                "Cartão de Crédito",
                "Cartão de Débito",
                "Cartão da Loja",
                "Vale Alimentação",
                "Vale Refeição",
                "Vale Presente",
                "Vale Combustível",
                "Boleto Bancário",
                "Depósito Bancário",
                "Pagamento Instantâneo (PIX) - Dinâmico",
                "Transferência bancária, Carteira Digital",
                "Programa de fidelidade, Cashback, Crédito Virtual",
                "Pagamento Instantâneo (PIX) - Estático",
                "Crédito em Loja",
                "Pagamento Eletrônico não Informado - falha de hardware do sistema emissor",
                "Sem pagamento",
                "Pagamento Posterior",
                "Outros"
            ],
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            itemsData: [],
            objNf: {
                nomeDestinatario: null,
                dataSaida: new Date().toISOString().split('T')[0],
                cep: '',
                cidade: '',
                codigoCidade: '',
                logradouro: '',
                bairro: '',
                numero: '',
                complemento: '',
                status: '',
                naturezaOp: null,
                cnpj: null,
                uf: '',
                meioPagamento: '',
                defFiscais: null,
                ncm: null,
                cest: null,
                cfop: null,
                valorUnitario: 0,
                quantidade: 0,
                icms: null,
                baseIcms: null,
                valueIcms: null,
                condPag: '',
                job: '',
                os: '',
                romaneio: [],
                email: '',
                itens: [],
                notaFiscalMae: '',
                addRetirada: false,
                transportadora: '',
                pesoBruto: null,
                pesoLiquido: null,
                especie: null,
                marca: null,
                numeracao: null,
                valorFrete: 0,
                valorSeguro: 0,
                valorDesconto: 0,
                valorOutros: 0,
                informacaoAdd: '',
                codigoBeneficioFiscal: ''
            }
        }
    },
    computed: {
        temRomaneio() {
            return Array.isArray(this.objNf?.romaneio) && this.objNf.romaneio.length > 0
        },

        valorNotaCalculado() {
            return this.normalizeMoneyValue(this.valorNota);
        },

        valorNotaFormatado() {
            return this.valorNotaCalculado.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' });
        },

        totalComImpostos() {
            return this.calcularTotalComImpostos();
        },
                // atualizarTotalComImpostos() {
                //     // Força atualização do total com impostos
                //     this.componentKey += 1;
                // },
        totalComImpostosFormatado() {
            return this.totalComImpostos.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' });
        }
    },
    methods: {
        normalizeMoneyValue(value) {
            if (value == null || value === '') return 0;

            if (typeof value === 'number') {
                return Number.isFinite(value) ? value / 100 : 0;
            }

            const sanitizedValue = String(value)
                .trim()
                .replace(/\s/g, '')
                .replace(/[^\d,.-]/g, '');

            if (!sanitizedValue) return 0;

            const lastCommaIndex = sanitizedValue.lastIndexOf(',');
            const lastDotIndex = sanitizedValue.lastIndexOf('.');
            const separatorIndex = Math.max(lastCommaIndex, lastDotIndex);

            if (separatorIndex === -1) {
                const integerValue = Number(sanitizedValue.replace(/[.,]/g, ''));
                return Number.isFinite(integerValue) ? integerValue / 100 : 0;
            }

            const integerPart = sanitizedValue.slice(0, separatorIndex).replace(/[.,]/g, '');
            const decimalPart = sanitizedValue.slice(separatorIndex + 1).replace(/[.,]/g, '');
            const normalizedValue = `${integerPart || '0'}.${decimalPart || '0'}`;
            const numericValue = Number(normalizedValue);

            return Number.isFinite(numericValue) ? numericValue : 0;
        },

        calcularTotalComImpostos() {
            let total = this.valorNotaCalculado;

            if (this.arrayItems && this.arrayItems.length > 0) {
                this.arrayItems.forEach((item) => {
                    total += this.normalizeMoneyValue(item.ipiValor);
                    total += this.normalizeMoneyValue(item.valorFrete);
                    total += this.normalizeMoneyValue(item.valorSeguro);
                    total -= this.normalizeMoneyValue(item.valorDesconto);
                    total += this.normalizeMoneyValue(item.valorOutros);
                });
            }

            return total;
        },

        totImpostos () {
            const total = this.calcularTotalComImpostos();

            this.componentKey += 1; // Força atualização do componente para refletir o novo total
            return total;
        },
        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },

        sumParcelas(){
            let sum = 0
            this.parcelas?.map((p) => {
                if (p.vrlParcela) sum += this.normalizeMoneyValue(p.vrlParcela)
            })

            return sum || 0
        },

        toMoneyCentsFromReais(value) {
            return Math.round((Number(value || 0) + Number.EPSILON) * 100)
        },

        sumParcelasInCents() {
            return this.toMoneyCentsFromReais(this.sumParcelas())
        },

        totalComImpostosInCents() {
            return this.toMoneyCentsFromReais(this.totalComImpostos)
        },

        podeAdicionarParcela() {
            return this.sumParcelasInCents() <= this.totalComImpostosInCents()
        },

        validarTotalParcelas() {
            return this.sumParcelasInCents() <= this.totalComImpostosInCents()
                || `A soma das parcelas não pode ultrapassar o total (${this.totalComImpostosFormatado})`;
        },

        async getCnpjInfo(value){

            if(value?.length == 18){
                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: value.replace(/\D/g, '')
                        } 
                    })


                if(response.data.data.data.status == "ERROR"){
                    this.$notfy.error("CNPJ invalido.");
                    // this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                const info = response.data.data.data

                this.objNf.uf = info.uf
                this.objNf.email = info.email

                this.objNf.bairro = info.bairro
                this.objNf.cidade = info.municipio
                this.objNf.logradouro = info.logradouro
                this.objNf.numero = info.numero
                this.objNf.cep = info.cep
                this.objNf.complemento = info.complemento

                this.componentKey += 1
            }
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            valor = valor.toString().trim();

            // Caso especial: "395.039.30" -> "395039,30"
            const partes = valor.split(".");
            if (partes.length > 2 && !valor.includes(",")) {
                const decimal = partes.pop(); // pega o último como decimal
                valor = partes.join("") + "," + decimal; 
            }

            return parseFloat(
                valor.replace(/\./g, "")   // remove milhar
                    ?.replace(",", ".")    // vírgula -> ponto decimal
            ) || 0;
        },

        sumItems(){
            let sum = 0
            this.arrayItems?.map((item) => {
                console.log('valor total >>> ', item.valorTotal, this.parseMoeda(item.valorTotal))
                sum += Number(String(item.valorTotal)?.replace(/\./g, '')?.replace(',', '') || 0)
            })
            //console.log('sum itens ', sum)
            this.$emit('sumItens', sum)
        },

        getFisTipiOptions () {
            Vue.prototype.$http.get(`/Entity/FisTipi`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.fisTipiOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching FisTipi options:", error);
            });
        },

        getOperacaoFiscalOptions () {
            Vue.prototype.$http.get(`/Entity/FisOper`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.operacaoFiscalOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Operacao Fiscal options:", error);
            });
        },

        getCFOPs(){
            // NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): restringe o CFOP a
            // 5.922/6.922 (Simples Faturamento), pra reduzir erro do usuário final.
            const valueFiltro = this.isNfRemessa
                ? '[5901,6901,5905,6905,5912,6912,5910,6910,5949]'
                : this.isVendaFutura
                    ? '[5922,6922]'
                    : undefined

            Vue.prototype.$http.get(`/Entity/CFOP/search-fields`, {
                params: {
                    page: 1,
                    limit: 9999,
                    searchFields: '[codigo]',
                    value: valueFiltro
                }
            }).then(response => {
                this.cfops = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cfops options:", error);
            });
        },
        
        selectedCfop(value){
            const cfopSelected = this.cfops.filter((cfop) => cfop.codigo == value)[0] || []

            this.objNf.naturezaOp = cfopSelected?.descricao || ''
            this.objNf.operacaoFiscal = cfopSelected.operacaoFiscal

            this.componentKey += 1
        },

        getRelationId(value) {
            if (Array.isArray(value)) return this.getRelationId(value[0])
            if (value && typeof value === 'object') return value?._id || value?.id || ''
            return value || ''
        },

        romaneioIndisponivel(romaneio = {}) {
            return !!this.getRelationId(romaneio?.fisDocEmiId)
        },

        // MELHORIA (a pedido do usuário): antes só avisava "Nota fiscal já emitida", sem dizer QUAL
        // nota - agora mostra o número (campo "fisDocEmiNumero", resolvido em getRomaneios() no
        // CreateIssuanceInvoiceView.vue a partir do FisDocEmi vinculado ao romaneio).
        romaneioItemText(romaneio = {}) {
            const codigo = romaneio?.codigo || romaneio?._id || romaneio?.id || 'Sem código'
            if (!this.romaneioIndisponivel(romaneio)) return codigo

            return romaneio?.fisDocEmiNumero
                ? `${codigo} - Nota fiscal ${romaneio.fisDocEmiNumero} já emitida`
                : `${codigo} - Nota fiscal já emitida`
        },

        alertarRomaneioIndisponivel(romaneio = {}) {
            if (!this.romaneioIndisponivel(romaneio)) return

            const mensagemNota = romaneio?.fisDocEmiNumero
                ? `pela nota fiscal ${romaneio.fisDocEmiNumero}`
                : 'por uma nota fiscal'

            this.$notfy.warning(`O romaneio ${romaneio?.codigo || ''} já foi utilizado ${mensagemNota} e não pode ser selecionado.`)
        },

        // BUGFIX (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): o registro bruto de
        // ProjectItens usa nomes de campo diferentes dos esperados pelo dialog de item da Nota
        // Fiscal (CreateItensNotaFiscalView.vue usa valorUnitario/valorTotal/icmsBaseCalculo/
        // icmsPercentual/icmsValor/ipi.../pis.../cofins..., enquanto ProjectItens usa
        // precoUnitario/precoTotal/baseCalculoICMS/porcentagemICMS/valorICMS etc). Sem esse
        // mapeamento o item entrava na nota com Valor Unitário/Total e todas as bases de
        // ICMS/IPI/PIS/COFINS zeradas. ProjectItens não tem CEST nem os códigos CTS — esses
        // continuam ficando em branco pro usuário escolher manualmente ao abrir o item.
        mapJobItemParaItemNota(item = {}) {
            const quantidade = item?.quantidade != null && item.quantidade !== '' ? Number(item.quantidade) : 1
            const valorUnitario = Number(item?.precoUnitario) || 0
            const valorTotalBruto = Number(item?.precoTotal) || 0
            const valorTotal = valorTotalBruto > 0 ? valorTotalBruto : Math.round((valorUnitario * quantidade) * 100) / 100

            // BUGFIX (Nota de Venda Futura — itens somem ao salvar): remove id/_id/campos de
            // auditoria do ProjectItens do spread, senão o id do item do Job vaza pro item da
            // Nota Fiscal e createItensPreNota() trata o item como já existente (updateMany, que
            // não encontra nada) em vez de criar (insertMany) — resultado: nota salva com itens:[].
            const {
                id: _jobItemId,
                _id: _jobItemMongoId,
                createAt: _jobItemCreateAt,
                createBy: _jobItemCreateBy,
                updateAt: _jobItemUpdateAt,
                updateBy: _jobItemUpdateBy,
                deleteAt: _jobItemDeleteAt,
                deleteBy: _jobItemDeleteBy,
                isDeleted: _jobItemIsDeleted,
                ...itemSemAuditoria
            } = item || {}

            return {
                ...itemSemAuditoria,
                quantidade,
                valorUnitario,
                valorTotal,
                icmsBaseCalculo: Number(item?.baseCalculoICMS) || 0,
                icmsPercentual: item?.porcentagemICMS != null && item.porcentagemICMS !== '' ? String(item.porcentagemICMS) : '',
                icmsValor: Number(item?.valorICMS) || 0,
                ipiBaseCalculo: Number(item?.baseCalculoIPI) || 0,
                ipiPercentual: item?.porcentagemIPI != null && item.porcentagemIPI !== '' ? String(item.porcentagemIPI) : '',
                ipiValor: Number(item?.valorIPI) || 0,
                pisBaseCalculo: Number(item?.baseCalculoPIS) || 0,
                pisPercentual: item?.porcentagemPIS != null && item.porcentagemPIS !== '' ? String(item.porcentagemPIS) : '',
                pisValor: Number(item?.valorPIS) || 0,
                cofinsBaseCalculo: Number(item?.baseCalculoCOFINS) || 0,
                cofinsPercentual: item?.porcentagemCOFINS != null && item.porcentagemCOFINS !== '' ? String(item.porcentagemCOFINS) : '',
                cofinsValor: Number(item?.valorCOFINS) || 0,
            }
        },

        // BUGFIX (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): ProjectItens.ncm é um
        // id (referência ao cadastro de NCM), mas o combobox de NCM do dialog de item usa
        // item-value "codigo" (a string do NCM, não o id). Busca em lote os NCMs referenciados
        // pelos itens selecionados e devolve um mapa id -> codigo.
        async resolverCodigosNcm(itens = []) {
            const ids = [...new Set(itens.map((item) => item?.ncm).filter((ncmId) => ncmId && typeof ncmId === 'string'))]
            if (ids.length === 0) return {}

            try {
                const response = await Vue.prototype.$http.get('/Entity/NCM/search-fields', {
                    params: { ids: ids.join(','), page: 1, limit: ids.length }
                })
                const ncms = response?.data?.data?.data || []
                return ncms.reduce((mapa, ncm) => {
                    if (ncm?.id) mapa[ncm.id] = ncm?.codigo
                    return mapa
                }, {})
            } catch (error) {
                console.error('Error resolving NCM codes (Venda Futura):', error)
                return {}
            }
        },

        // NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): busca os itens do JOB
        // diretamente (ProjectItens), sem passar por Romaneio/Lista de Embarque/OS — mesmo
        // endpoint já usado pelo fluxo de Nota de Serviço (NotaFiscalServico.vue::selectedJob).
        async getJobItensDiretos(job) {
            const jobId = this.getRelationId(job)
            if (!jobId) {
                this.jobItensDisponiveis = []
                return
            }

            if (jobId === this.ultimoJobIdCarregado) return

            this.loadingJobItensDiretos = true
            try {
                const responseJob = await Vue.prototype.$http.get(`/Entity/Project/${jobId}`)
                const jobEntity = responseJob?.data?.data || {}

                const jobItensIds = Array.isArray(jobEntity?.jobItens)
                    ? jobEntity.jobItens.filter(Boolean)
                    : []

                if (jobItensIds.length === 0) {
                    this.jobItensDisponiveis = []
                    this.ultimoJobIdCarregado = jobId
                    return
                }

                const response = await Vue.prototype.$http.get('/Entity/ProjectItens', {
                    params: { ids: jobItensIds.join(',') }
                })

                this.jobItensDisponiveis = response?.data?.data?.data || []
                this.ultimoJobIdCarregado = jobId
            } catch (error) {
                console.error('Error fetching job itens (Venda Futura):', error)
                this.jobItensDisponiveis = []
            } finally {
                this.loadingJobItensDiretos = false
            }
        }
    },
    watch: {
        item: {
            async handler(value){
                this.objNf = value
            },
            deep: true,
            immediate: true
        },

        pacelasCads: {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.parcelas = value
                }
            },
            deep: true,
            immediate: false
        },

        objNf: {
            handler(value){
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['objNf.itens']: {
            async handler(itens){
                const romaneiosSelecionados = this.objNf?.romaneio
                // BUGFIX (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): esta nota nunca
                // preenche objNf.romaneio (não usa Romaneio), então o guard original sempre zerava
                // arrayItems/osItems e o carregamento de uma nota já salva (Editar/Duplicar) ficava
                // em branco. Com isVendaFutura, segue adiante mesmo sem romaneio selecionado.
                if (!this.isVendaFutura && (!Array.isArray(romaneiosSelecionados) || romaneiosSelecionados.length === 0)) {
                    this.arrayItems = []
                    this.osItems = []
                    return
                }

                if (itens?.length > 0) {
                    const response = await Vue.prototype.$http('/Entity/FisPreDocEmiItem/search-fields', {
                        params: {
                            ids: itens.map((item) => item).join(','),
                            sortField: 'sequencia'
                        }
                    })

                    // BUGFIX (Nota de Remessa/Venda - itens somem/quebram ao reabrir nota já salva):
                    // havia um ".data" a mais aqui. response.data = {success, data:{data:[...],...}}
                    // do endpoint /search-fields, ou seja response.data.data.data já É o array de
                    // itens (mesmo valor usado para osItems, uma linha abaixo). Com o ".data" extra,
                    // arrayItems virava undefined sempre que a nota já tinha itens salvos (objNf.itens
                    // preenchido) — o que por sua vez deixava o prop "item" da tabela de itens vazio
                    // (mascarado antes pelo recálculo indevido do watcher itemsByRomaneio) e o
                    // "nfItens" do componente pai undefined, quebrando o Salvar com
                    // "Cannot read properties of undefined (reading 'length')".
                    this.arrayItems = response.data.data.data
                    this.osItems = response.data.data.data
                } else {
                    this.arrayItems = []
                    this.osItems = []
                }
            },
            deep: true,
            immediate: true
        },

        ['objNf.romaneio']: {
            async handler(romaneio) {

                const romaneiosSelecionados = Array.isArray(romaneio) ? romaneio : []
                const indisponiveis = romaneiosSelecionados.filter((item) => this.romaneioIndisponivel(item))

                if (indisponiveis.length > 0) {
                    indisponiveis.forEach((item) => this.alertarRomaneioIndisponivel(item))
                    this.objNf.romaneio = romaneiosSelecionados.filter((item) => !this.romaneioIndisponivel(item))
                    return
                }

                this.osItems = []
                if (!Array.isArray(romaneio) || romaneio.length === 0) {
                    this.arrayItems = []
                    this.objNf.itens = []
                    this.parcelas = []
                    return
                }

                // restaura parcelas: usa pacelasCads do pai se existir, senão padrão
                if (!this.parcelas || this.parcelas.length === 0) {
                    if (Array.isArray(this.pacelasCads) && this.pacelasCads.length > 0) {
                        this.parcelas = [...this.pacelasCads]
                    } else {
                        this.parcelas = [{ numParcela: '01', vencimento: null, vrlParcela: 0 }]
                    }
                }

                if(romaneio?.length > 0){

                    this.objNf.transportadora = romaneio[0]?.transportadora || this.objNf.transportadora
                    this.objNf.quantidade = romaneio[0]?.quantidade || this.objNf.quantidade
                    this.objNf.numeracao = romaneio[0].numeracao
                    this.objNf.pesoLiquido = romaneio[0].pesoLiquido
                    this.objNf.pesoBruto = romaneio[0].pesoBruto
                    this.objNf.especie = romaneio[0].especie
                    this.objNf.marca = romaneio[0].marca

                    romaneio?.map((item) => {
                        item?.romaneiopackinglist?.map((romaneioPacking) => {
                            romaneioPacking.listaDeEmbarqueItem?.map((listEmbItem) => {
                                // Base do itemJob (mesma origem de ncm/cest usada na Nota de Venda)
                                const itemJobBase = listEmbItem.ordemDeServico[0]?.itemJob[0] || {}
                                const unidadeSiglaBase = listEmbItem.itenListPacking?.[0]?.unidadeSigla
                                    || listEmbItem.itenListPacking?.[0]?.ordemServico?.[0]?.unidadeSigla
                                    || itemJobBase?.unidadeSigla

                                if(!this.isNfRemessa){
                                    this.osItems.push({ ...itemJobBase, unidadeSigla: unidadeSiglaBase })
                                } else {
                                    listEmbItem.itenListPacking?.map((itenListPacking) => {
                                        // Remove id/_id para forçar o mesmo cálculo de ncm/cest/valores feito na Nota de Venda
                                        const { id, _id, ...itenListPackingSemId } = itenListPacking || {}
                                        this.osItems.push({
                                            ...itemJobBase,
                                            ...itenListPackingSemId,
                                            ordemDeServicoItem: listEmbItem.ordemDeServicoItem || itenListPacking?.ordemDeServicoItem,
                                            itemCodigo: itenListPacking?.itemCodigo || itemJobBase?.itemCodigo,
                                            itemCodigoExt: itenListPacking?.itemCodigoExt || itemJobBase?.itemCodigoExt,
                                            unidadeSigla: itenListPacking?.unidadeSigla
                                                || itenListPacking?.ordemServico?.[0]?.unidadeSigla
                                                || unidadeSiglaBase
                                        })
                                    })
                                }
                            })
                        })
                    })
                }

            },
            deep: true,
            immediate: true
        },

        async jobSelected(job) {
            // Venda Futura: o CFOP (5922/6922) é escolhido manualmente; se o JOB não tem CFOP
            // cadastrado, não apaga o que o usuário já selecionou.
            const cfopDoJob = job.cfopCodigo || (this.isVendaFutura ? this.objNf.cfop : undefined);
            this.objNf.cfop = cfopDoJob;
            this.selectedCfop(cfopDoJob);
            this.componentKey += 1;

            // NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): sem Romaneio, os
            // itens candidatos da nota vêm direto do JOB selecionado (ProjectItens).
            if (this.isVendaFutura) {
                // BUGFIX (portado do DeltaDev — Nota de Venda Futura): ao TROCAR o JOB depois de já
                // ter escolhido item(ns), os itens do JOB anterior continuavam selecionados e na
                // tabela. Se o JOB mudou em relação ao último carregado (ultimoJobIdCarregado só é
                // preenchido após a 1ª seleção — abrir/editar nota salva ou a 1ª escolha de JOB não
                // limpam nada), zera seleção, pool de candidatos e itens da nota.
                const novoJobId = this.getRelationId(job)
                if (this.ultimoJobIdCarregado && novoJobId !== this.ultimoJobIdCarregado) {
                    this.jobItensSelecionados = []
                    this.jobItensDisponiveis = []
                    this.osItems = []
                    this.arrayItems = []
                    if (this.objNf) this.objNf.itens = []
                }
                await this.getJobItensDiretos(job)
            }
        },

        // NOVO (portado do DeltaDev, 2026-10-02 — Nota de Venda Futura): o usuário escolhe,
        // dentre os itens do JOB carregados por getJobItensDiretos(), quais entram na nota —
        // osItems é o mesmo "pool" de candidatos que o fluxo com Romaneio monta acima.
        jobItensSelecionados: {
            async handler(itensSelecionados) {
                if (!this.isVendaFutura) return

                const itens = Array.isArray(itensSelecionados) ? itensSelecionados : []
                if (itens.length === 0) {
                    this.osItems = []
                    return
                }

                const codigosNcm = await this.resolverCodigosNcm(itens)

                this.osItems = itens.map((item) => {
                    const itemMapeado = this.mapJobItemParaItemNota(item)
                    return {
                        ...itemMapeado,
                        ncm: item?.ncm && codigosNcm[item.ncm] ? codigosNcm[item.ncm] : ''
                    }
                })
            },
            deep: true,
            immediate: false
        },

        arrayItems: {
            handler(value){
                this.$emit('itens-nf', value)
            },
            immediate: true,
            deep: true
        },

        async expasionInfoGerais(value){
            // if(value && this.romaneios.length == 0){
            //     this.romaneios = await this.getDataEntity('Romaneio')
            // }
        },

        parcelas: {
            handler(value){
                this.$emit('parcelas', value)
            },
            deep: true
        },

        userInfo: {
            handler(value){
                if(value.cnpj) {
                    this.objNf.cnpj = value?.cnpj
                    this.getCnpjInfo(value?.cnpj)
                }
            },
            deep: true
        },
    },
    async created() {

        this.transportadoras = await this.getDataEntity('Fornecedor')

        await Promise.all([
            //this.getOperacaoFiscalOptions(),
            this.getCFOPs(),
        ]);

    }
}
</script>